
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import flatTypeDescriptor from './DatasetManagementFlatDataset.json'
import Dropdown from 'primevue/dropdown'
import Card from 'primevue/card'

export default defineComponent({
    components: { Card, Dropdown, KnValidationMessages },
    props: { selectedDataset: { type: Object as any }, dataSources: { type: Array as any } },
    emits: ['touched'],
    data() {
        return {
            flatTypeDescriptor,
            dataset: {} as any,
            v$: useValidate() as any
        }
    },
    created() {
        this.dataset = this.selectedDataset
    },
    watch: {
        selectedDataset() {
            this.dataset = this.selectedDataset
        }
    },
    validations() {
        const flatFieldsRequired = (value) => {
            return this.dataset.dsTypeCd != 'Flat' || value
        }
        const customValidators: ICustomValidatorMap = { 'flat-fields-required': flatFieldsRequired }
        const validationObject = { dataset: createValidations('dataset', flatTypeDescriptor.validations.dataset, customValidators) }
        return validationObject
    },
    methods: {
        changeTypeWarning() {
            this.$store.commit('setInfo', { title: this.$t('documentExecution.registry.warning'), msg: this.$t('managers.datasetManagement.changeTypeMsg') })
        }
    }
})
